import React, { Component } from 'react'
import PropTypes from 'prop-types'

class PDF extends Component {
  render () {
    const {
      content
    } = this.props

    return (
      <object data={content} type='application/pdf' width='100%' height='100%'>
        <p>This browser does not support PDFs</p>
      </object>
    )
  }
}

PDF.propTypes = {
  content: PropTypes.string
}

export default PDF



// WEBPACK FOOTER //
// ./src/components/contentDisplay/PDF.js